export default "__VITE_ASSET__OkA9GoS0__"